if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.initForm();
      }

      connectedCallback() {
        this.initForm();
      }

      initForm() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.initialized) return;
        this.initialized = true;

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartNotification = document.querySelector('cart-notification');
        // Always prefer cart-drawer if it exists
        this.cart = this.cartDrawer || this.cartNotification;
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (this.cartDrawer && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        if (this.submitButton) {
          this.submitButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.onSubmitHandler(evt);
          });
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        if (evt) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        if (!this.submitButton) {
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        }

        // Block double-clicks
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton && this.submitButton.hasAttribute('disabled')) return;

        this.handleErrorMessage();
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal && quickAddModal.openedBy) {
            this.cart.setActiveElement(quickAddModal.openedBy);
          } else {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error from Shopify (e.g. sold out, invalid variant)
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              // No drawer or notification — redirect to cart page
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            // Notify subscribers (e.g. cart count bubble updates)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // Render the updated cart sections and OPEN the drawer
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.cart.renderContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Add to cart error:', e);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            // Always reset button state so it's never stuck
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const buyNowBtn = this.form?.querySelector('.new-buy-now-btn');
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if (buyNowBtn) {
            buyNowBtn.setAttribute('disabled', 'disabled');
            buyNowBtn.classList.add('gokwik-sold-out');
            buyNowBtn.style.opacity = '0.5';
            buyNowBtn.style.pointerEvents = 'none';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if (buyNowBtn) {
            buyNowBtn.removeAttribute('disabled');
            buyNowBtn.classList.remove('gokwik-sold-out');
            buyNowBtn.style.opacity = '';
            buyNowBtn.style.pointerEvents = '';
            if (this.variantIdInput?.value) {
              buyNowBtn.setAttribute('data-variant-id', this.variantIdInput.value);
            }
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
